/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Replace_TitleInputs */



/**
* | output |
* | --- |
* | "Record again?" |
*
* @param {Meeting_Offline_Replace_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_replace_title = /** @type {((inputs?: Meeting_Offline_Replace_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Replace_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opnieuw opnemen?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer à nouveau ?")
	return /** @type {LocalizedString} */ ("Record again?")
});